// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 11 13" {...rest} unit={unit}>
		<g transform="translate(-25.000000, -24.000000)" fill="#FFFFFF">
			<path d="M29.6751337,31.7687166 C27.4766043,31.0213904 25.3736631,29.9351604
			25.3736631,27.6236631 C25.3736631,25.4164439 27.4331551,24 30.2747326,24
			C33.0989305,24 35.0454545,25.5467914 35.0454545,27.953877 L31.7780749,27.953877
			C31.7780749,27.1370321 31.3001337,26.5808824 30.2052139,26.5808824
			C29.1537433,26.5808824
			28.6410428,27.0588235 28.6410428,27.6584225 C28.6410428,28.3188503 29.5274064,28.709893
			30.8048128,29.1356952 C33.5508021,30.013369 35.0280749,31.2647059 35.0280749,33.3937166
			C35.0280749,35.7052139 33.2032086,37 30.3181818,37 C27.6851604,37 25,35.6704545
			25,32.6463904 L28.2847594,32.6463904 C28.2847594,33.9759358 28.9278075,34.4364973
			30.3181818,34.4364973
			C31.3870321,34.4364973 31.7520053,33.9498663 31.7520053,33.4110963
			C31.7520053,32.7419786
			31.4826203,32.3770053 29.6751337,31.7687166 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/S.js